import LinkTo from "components/navigation/link/LinkTo";
import { DlUnit } from "model/dl_unit/DlUnit";
import React from "react";

type UnitCatProps = {
  item: DlUnit;
  catInd: number;
};

const UnitCat: React.FC<UnitCatProps> = ({ item, catInd }) => {
  const f700a = item.fValGet("700_a");
  const f700b = item.fValGet("700_b");
  const f200a = item.fValGet("200_a");
  const f200e = item.fValGet("200_e");
  const f210a = item.fValGet("210_a");
  const f210c = item.fValGet("210_c");
  const f210d = item.fValGet("210_d");
  const f901a = item.fValGet("901_a");
  const f901b = item.fValGet("901_b");
  const f303a = item.fValGet("303_a");
  const f710a = item.fValGet("710_a");
  const f710e = item.fValGet("710_e");
  const f710f = item.fValGet("710_f");
  const num = item.num;

  let autor = f700a + ", " + f700b;
  let naslov = f200a + "; " + f200e;
  let izdavac = f210a + ", " + f210c + ", " + f210d;
  let autor_teksta = f901a + "; " + f901b;
  let napomena = f303a;
  let mesto_odrzavanja = f710a + ", " + f710e + ", " + f710f;
  let broj_zapisa = num;

  const linkScanNav =
    item.scans.length > 0 ? (
      <LinkTo to={`/u/${item.slug}`} target="_blank">
        <img src="/images/nav/listanje.png" alt="art foto" />
      </LinkTo>
    ) : null;

  return (
    <div key={`catInd_${catInd}`}>
      Autor: {f700a !== "" || f700b !== "" ? autor : ""}
      <br />
      Naslov: {f200a !== "" || f200e !== "" ? naslov : ""}
      <br />
      Izdavač: {f210a !== "" || f210c !== "" || f210d !== "" ? izdavac : ""}
      <br />
      Autor teksta: {f901a !== "" || f901b !== "" ? autor_teksta : ""}
      <br />
      Mesto održavanja:{" "}
      {f710a !== "" || f710e !== "" || f710f !== "" ? mesto_odrzavanja : ""}
      <br />
      Napomena: {f303a !== "" ? napomena : ""}
      <br />
      Broj zapisa: {broj_zapisa !== 0 ? broj_zapisa : ""}
      <br />
      {linkScanNav}
      &nbsp;&nbsp;
      <br />
      <br />
    </div>
  );
};

export default UnitCat;
